import { AloftPrice } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import {
  selectImprovementEntityIds,
  selectImprovementsEntities,
} from '../propertyDataSelectors/improvementsSelectors.ts';
import { createPriceSelector } from '../utils/createPriceSelector.ts';

const calculateManualCost = (
  improvements: ReturnType<typeof selectImprovementsEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];

  const { manualCost } = improvementsForTransaction ?? {};

  if (!manualCost) return undefined;

  return {
    totalCost: AloftPrice.schema.parse(manualCost),
  };
};

const getTotalManualCost = (
  improvements: ReturnType<typeof selectImprovementsEntities>,
  id: string,
) => {
  const costOutput = calculateManualCost(improvements, id);

  if (!costOutput) return AloftPrice.zero;
  return costOutput.totalCost;
};

export const selectManualCost = createPriceSelector(
  [selectImprovementsEntities, (_state, id: string) => id],
  getTotalManualCost,
);

export const selectManualCosts = createSelector(
  [selectImprovementsEntities, selectImprovementEntityIds],
  (improvements, improvementEntityIds) =>
    improvementEntityIds.reduce((acc: Record<string, AloftPrice>, propID) => {
      const cost = getTotalManualCost(improvements, propID);
      if (cost) acc[propID] = cost;
      return acc;
    }, {}),
);

export const selectManualCostDisplay = createSelector([selectManualCost], (manualCost) =>
  manualCost?.toString(true),
);
